import type {
  ProactivityExperimentDeliveryKind,
  ProactivityExperimentRoutineAgentMode,
  ProactivityExperimentRoutineKind,
} from './proactivity-experiments-types';

export const DELIVERY_KINDS = [
  'card_prompt',
  'direct_chat',
  'direct_routine',
] as const satisfies readonly ProactivityExperimentDeliveryKind[];

export const DELIVERY_KIND_LABELS: Record<
  ProactivityExperimentDeliveryKind,
  string
> = {
  card_prompt: 'Card prompt',
  direct_chat: 'Direct chat',
  direct_routine: 'Direct routine',
};

export const DELIVERY_KIND_DESCRIPTIONS: Record<
  ProactivityExperimentDeliveryKind,
  string
> = {
  card_prompt:
    'Each recipient gets a Home card. Start chat sends this prompt immediately, without review or editing.',
  direct_chat:
    'Each recipient gets a new chat in which this prompt runs once as a system note, without user action.',
  direct_routine:
    'Each recipient gets a routine that runs this prompt on the schedule below, without a chat.',
};

export const ROUTINE_KINDS = [
  'digest',
  'watcher',
  'reminder',
] as const satisfies readonly ProactivityExperimentRoutineKind[];

export const ROUTINE_KIND_HELP: Record<
  ProactivityExperimentRoutineKind,
  string
> = {
  digest: '"Digest" routines produce a normal report on every run.',
  watcher:
    '"Watcher" routines can hold their notification and retire themselves once their condition is met.',
  reminder: '"Reminder" routines send the prompt verbatim, no model call.',
};

export const ROUTINE_AGENT_MODES = [
  'lite',
  'regular',
  'max',
  'ultra',
  'god',
] as const satisfies readonly ProactivityExperimentRoutineAgentMode[];
